import { render, staticRenderFns } from "./Organisation.vue?vue&type=template&id=a25e15d8&"
import script from "./Organisation.vue?vue&type=script&lang=js&"
export * from "./Organisation.vue?vue&type=script&lang=js&"
import style0 from "./Organisation.vue?vue&type=style&index=0&id=a25e15d8&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a25e15d8')) {
      api.createRecord('a25e15d8', component.options)
    } else {
      api.reload('a25e15d8', component.options)
    }
    module.hot.accept("./Organisation.vue?vue&type=template&id=a25e15d8&", function () {
      api.rerender('a25e15d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Organisation.vue"
export default component.exports